import axios from 'axios';
import { baseUrl } from '../hooks/useEndpoints';
import {
  IFieldExercise,
  IFieldExerciseGroup,
  IFieldBlock,
  IFieldWorkout,
  AssignFieldWorkoutBody,
  AssignFieldWorkoutResponse,
} from '../models/field-programming';

interface Paginated<T> {
  docs: T[];
  totalDocs: number;
  page: number;
  totalPages: number;
}

export const fieldProgrammingEndpoints = {
  exerciseGroups: {
    list: () =>
      axios.get<IFieldExerciseGroup[]>(`${baseUrl}/field-programming/exercise-groups`),
  },
  exercises: {
    list: (params: { search?: string; groupId?: string; page?: number; limit?: number }) =>
      axios.get<Paginated<IFieldExercise>>(`${baseUrl}/field-programming/exercises`, { params }),
    get: (id: string) =>
      axios.get<IFieldExercise>(`${baseUrl}/field-programming/exercises/${id}`),
  },
  blocks: {
    list: (params: {
      search?: string;
      tacticalPhase?: string;
      blockType?: string;
      page?: number;
      limit?: number;
    }) =>
      axios.get<Paginated<IFieldBlock>>(`${baseUrl}/field-programming/blocks`, { params }),
    get: (id: string) =>
      axios.get<IFieldBlock>(`${baseUrl}/field-programming/blocks/${id}`),
    create: (body: Partial<IFieldBlock>) =>
      axios.post<IFieldBlock>(`${baseUrl}/field-programming/blocks`, body),
    update: (id: string, body: Partial<IFieldBlock>) =>
      axios.patch<IFieldBlock>(`${baseUrl}/field-programming/blocks/${id}`, body),
    delete: (id: string) =>
      axios.delete<{ ok: true }>(`${baseUrl}/field-programming/blocks/${id}`),
    duplicate: (id: string) =>
      axios.post<IFieldBlock>(`${baseUrl}/field-programming/blocks/${id}/duplicate`),
  },
  workouts: {
    list: (params: { search?: string; sport?: string; page?: number; limit?: number }) =>
      axios.get<Paginated<IFieldWorkout>>(`${baseUrl}/field-programming/workouts`, { params }),
    get: (id: string) =>
      axios.get<IFieldWorkout>(`${baseUrl}/field-programming/workouts/${id}`),
    create: (body: Partial<IFieldWorkout>) =>
      axios.post<IFieldWorkout>(`${baseUrl}/field-programming/workouts`, body),
    update: (id: string, body: Partial<IFieldWorkout>) =>
      axios.patch<IFieldWorkout>(`${baseUrl}/field-programming/workouts/${id}`, body),
    delete: (id: string) =>
      axios.delete<{ ok: true }>(`${baseUrl}/field-programming/workouts/${id}`),
    duplicate: (id: string) =>
      axios.post<IFieldWorkout>(`${baseUrl}/field-programming/workouts/${id}/duplicate`),
    assign: (id: string, body: AssignFieldWorkoutBody) =>
      axios.post<AssignFieldWorkoutResponse>(
        `${baseUrl}/field-programming/workouts/${id}/assign`,
        body,
      ),
  },
};
